import { useState, useEffect } from 'react';
import {
  Modal,
  ModalCloseButton,
  ModalContent,
  ModalOverlay,
  ModalFooter,
  ModalHeader,
  ModalBody,
  Drawer,
  DrawerCloseButton,
  DrawerOverlay,
  DrawerContent,
  DrawerFooter,
  DrawerBody,
  DrawerHeader,
  VStack,
  Center,
  HStack,
  Text,
  Button,
  Icon,
  Divider,
} from '@chakra-ui/react';

import { IoCheckmarkOutline, IoLeafOutline } from 'react-icons/io5';

import * as fp from 'lodash/fp';

import mediaQueryStateAtom from '~/recoil/atom/mediaQueryState';
import { useRecoilValue } from 'recoil';

type TagFilterModalProps = {
  isOpen: boolean;
  tags: Array<string>;
  selectedTags: Array<string>;
  onClose: () => void;
  onConfirm: (tags: Array<string>) => void;
};

export default function TagFilterModal({
  isOpen,
  tags,
  selectedTags,
  onClose,
  onConfirm,
}: TagFilterModalProps) {
  const [newSelectedTags, setNewSelectedTags] = useState<Array<string>>(selectedTags);
  const { isLargerThan768 } = useRecoilValue(mediaQueryStateAtom);

  useEffect(() => {
    isOpen && setNewSelectedTags(selectedTags);
  }, [isOpen, selectedTags]);

  const handleOnClickTag = (tag: string) => {
    const isIncluded = newSelectedTags.includes(tag);

    setNewSelectedTags((prev) => (isIncluded ? fp.pull(tag)(prev) : [...prev, tag]));
  };

  if (isLargerThan768) {
    return (
      <Modal isOpen={isOpen} onClose={onClose} isCentered scrollBehavior="inside">
        <ModalOverlay />
        <ModalContent h="95%">
          <ModalCloseButton />
          <ModalHeader borderBottom="1px solid" borderBottomColor="primary">
            <Center mt={4}>
              <HStack spacing={3}>
                <Icon as={IoLeafOutline} color="primary" boxSize="1.5rem" />
                <Text fontSize="xl" fontWeight="normal">
                  選擇素食
                </Text>
              </HStack>
            </Center>
          </ModalHeader>
          <ModalBody>
            <VStack
              justifyContent="flex-start"
              p={2}
              spacing={0}
              divider={<Divider color="gray.200" />}
            >
              <HStack
                justifyContent="space-between"
                alignSelf="stretch"
                onClick={() => setNewSelectedTags([])}
                cursor="pointer"
                py={2}
                key="all"
              >
                <Text
                  color={newSelectedTags.length === 0 ? 'primary' : 'fontColor'}
                  fontSize="md"
                  fontWeight="700"
                >
                  全部素食分類
                </Text>
                {newSelectedTags.length === 0 && (
                  <Icon as={IoCheckmarkOutline} color="primary" boxSize="1.5rem" />
                )}
              </HStack>
              {tags.map((tag) => (
                <HStack
                  justifyContent="space-between"
                  alignSelf="stretch"
                  onClick={() => handleOnClickTag(tag)}
                  cursor="pointer"
                  py={2}
                  key={tag}
                >
                  <Text
                    color={newSelectedTags.includes(tag) ? 'primary' : 'fontColor'}
                    fontSize="md"
                    fontWeight="700"
                  >
                    {tag}
                  </Text>
                  {newSelectedTags.includes(tag) && (
                    <Icon as={IoCheckmarkOutline} color="primary" boxSize="1.5rem" />
                  )}
                </HStack>
              ))}
            </VStack>
          </ModalBody>
          <ModalFooter p={0}>
            <Button
              isFullWidth
              size="lg"
              borderRadius="none"
              onClick={() => onConfirm(newSelectedTags)}
              justifyContent="space-between"
            >
              <HStack
                w="36px"
                h="36px"
                borderRadius="5px"
                bgColor="#513F24"
                justifyContent="center"
              >
                <Text color="white" fontSize="md" fontWeight="700" textAlign="center">
                  {newSelectedTags.length}
                </Text>
              </HStack>
              <Text color="white" fontSize="md" fontWeight="700">
                篩選條件
              </Text>
            </Button>
          </ModalFooter>
        </ModalContent>
      </Modal>
    );
  }
  return (
    <Drawer isOpen={isOpen} onClose={onClose} size="full">
      <DrawerOverlay />
      <DrawerContent>
        <DrawerCloseButton />
        <DrawerHeader borderBottom="1px solid" borderBottomColor="primary">
          <Center mt={4}>
            <HStack spacing={3}>
              <Icon as={IoLeafOutline} color="primary" boxSize="1.5rem" />
              <Text fontSize="xl" fontWeight="normal">
                選擇素食
              </Text>
            </HStack>
          </Center>
        </DrawerHeader>
        <DrawerBody>
          <VStack
            justifyContent="flex-start"
            p={2}
            spacing={0}
            divider={<Divider color="gray.200" />}
          >
            <HStack
              justifyContent="space-between"
              alignSelf="stretch"
              onClick={() => setNewSelectedTags([])}
              cursor="pointer"
              py={2}
              key="all"
            >
              <Text
                color={newSelectedTags.length === 0 ? 'primary' : 'fontColor'}
                fontSize="md"
                fontWeight="700"
              >
                全部素食分類
              </Text>
              {newSelectedTags.length === 0 && (
                <Icon as={IoCheckmarkOutline} color="primary" boxSize="1.5rem" />
              )}
            </HStack>
            {tags.map((tag) => (
              <HStack
                justifyContent="space-between"
                alignSelf="stretch"
                onClick={() => handleOnClickTag(tag)}
                cursor="pointer"
                py={2}
                key={tag}
              >
                <Text
                  color={newSelectedTags.includes(tag) ? 'primary' : 'fontColor'}
                  fontSize="md"
                  fontWeight="700"
                >
                  {tag}
                </Text>
                {newSelectedTags.includes(tag) && (
                  <Icon as={IoCheckmarkOutline} color="primary" boxSize="1.5rem" />
                )}
              </HStack>
            ))}
          </VStack>
        </DrawerBody>
        <DrawerFooter p={0} position="sticky" bottom={0}>
          <Button
            isFullWidth
            size="lg"
            borderRadius="none"
            onClick={() => onConfirm(newSelectedTags)}
            justifyContent="space-between"
          >
            <HStack w="36px" h="36px" borderRadius="5px" bgColor="#513F24" justifyContent="center">
              <Text color="white" fontSize="md" fontWeight="700" textAlign="center">
                {newSelectedTags.length}
              </Text>
            </HStack>
            <Text color="white" fontSize="md" fontWeight="700">
              篩選條件
            </Text>
          </Button>
        </DrawerFooter>
      </DrawerContent>
    </Drawer>
  );
}
